export default __webpack_public_path__ + "ff54ca7.png";